import { FiBriefcase, FiCheckSquare, FiCreditCard, FiFileText, FiGrid, FiUsers } from "react-icons/fi";

/**
 * Katalog modułów CODZIENNEJ pracy — JEDNO źródło prawdy dla menu bocznego i kafelków
 * pulpitu (lustro wzorca adminModules.js dla panelu administratora).
 *
 * Zasada (ustalenie klienta 2026-08-08): pulpit pokazuje dokładnie te kafelki, które dana
 * osoba ma w zakładkach menu — ani mniej (kafelek bez zakładki), ani więcej (zakładka bez
 * kafelka). Utrzymywane osobno listy w Sidebar.js i DashboardPage.js rozjeżdżały się przy
 * każdej zmianie uprawnień, więc obie powierzchnie czytają odtąd stąd.
 *
 * Panel administratora CELOWO nie jest wpisem tego katalogu: w menu i na pulpicie występuje
 * jako osobna pozycja/kafelek gated listą ADMIN_PERMISSION_KEYS (patrz adminModules.js).
 *
 * Pola: `permission` — klucz lub lista kluczy otwierających moduł (brak = widzi każdy
 * zalogowany pracownik); `description` — tekst kafelka na pulpicie (menu go nie używa);
 * `end` — dokładne dopasowanie trasy w NavLink (pulpit to "/", bez end świeciłby zawsze).
 */
export const APP_MODULES = [
    {
        key: "dashboard",
        routeKey: "dashboard",
        label: "Pulpit",
        icon: FiGrid,
        end: true,
        // Pulpit nie dostaje kafelka na samym sobie — opis zbędny.
        description: null,
    },
    {
        key: "passes",
        routeKey: "passes",
        label: "Przepustki",
        icon: FiFileText,
        description: "Składaj i przeglądaj wnioski o przepustki dla gości i pracowników.",
    },
    {
        key: "guard",
        routeKey: "guard",
        label: "Weryfikacja QR",
        icon: FiCheckSquare,
        permission: "GuardScan",
        description: "Skanuj kody QR przepustek i potwierdzaj wejścia na portierni.",
    },
    {
        key: "portalAccounts",
        routeKey: "portalAccounts",
        // Nazwa z 2026-08-09: „Konta przepustek" myliło się z rejestrem samych przepustek,
        // a moduł jest kartoteką LUDZI z zewnątrz. Adres trasy (/konta-przepustek) zostaje
        // bez zmian — zapisane linki i zakładki użytkowników muszą działać dalej.
        label: "Kartoteka wizytatorów",
        icon: FiUsers,
        // Dostęp do zakładki daje klucz PODGLĄDU; stary klucz Manage zostaje dla kont
        // nadanych przed rozbiciem uprawnień kartotek (2026-08-08).
        permission: ["PortalAccountsView", "PortalAccountsManage"],
        description: "Kartoteki osób zewnętrznych: dane, zgody RODO i wystawianie przepustek.",
    },
    {
        key: "companies",
        routeKey: "companies",
        label: "Firmy",
        icon: FiBriefcase,
        // Klucz PODGLĄDU, nie zarządzania: moduł pokazuje kartoteki firm i ich przepustki,
        // a zakładanie firm oraz kont przedstawicieli zostaje w panelu administratora
        // (CompaniesManage + PIN). Dzięki temu zakładkę może mieć zwykły pracownik obsługi.
        permission: "CompaniesView",
        description: "Kartoteki firm zewnętrznych: kto do nich należy i jakie ma przepustki.",
    },
    {
        key: "cards",
        routeKey: "cards",
        label: "Karty dostępu",
        icon: FiCreditCard,
        permission: ["CardView", "CardManage"],
        description: "Ewidencja kart: wydawanie, blokowanie i zwroty kart dostępu.",
    },
];

/**
 * Panel firmy (/firma) — CELOWO poza tablicą APP_MODULES, wzorem panelu administratora:
 * bramką nie jest klucz uprawnienia (jedyny filtr, jaki katalog zna), tylko powiązanie
 * konta z firmą (`user.companyId` z /users/me). Wpis w APP_MODULES pokazałby pozycję
 * wszystkim — pulpit filtruje kafelki wyłącznie po `permission`. Definicja mieszka tu
 * (nie inline w Sidebarze), żeby ewentualny kafelek pulpitu wziął ją z tego samego źródła.
 */
export const COMPANY_PANEL_MODULE = {
    key: "company",
    routeKey: "company",
    label: "Panel firmy",
    icon: FiBriefcase,
    description: "Kartoteki pracowników Twojej firmy i przepustki w ich imieniu.",
};
